import * as React from 'react';

import { ListPage } from 'shared/react-admin/Pages';

import { CommissionRecalculationTaskListContent } from './CommissionRecalculationTaskListContent/CommissionRecalculationTaskListContent';

export const CommissionRecalculationTaskList: React.FC = () => {
  return (
    <ListPage
      actions={[]}
      empty={false}
      headerTitle={{
        titleText: 'Задания на перерасчёт комиссий',
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <CommissionRecalculationTaskListContent />
    </ListPage>
  );
};
